<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="审批类型管理">
        <span slot="label">{{$t("tab.tab_approve_type")}}</span>
        <ApproveTypeSetting></ApproveTypeSetting>
      </el-tab-pane>
      <el-tab-pane label="审批用户管理">
        <span slot="label">{{$t("tab.tab_approve_user")}}</span>
        <ApproveUserSetting></ApproveUserSetting>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ApproveTypeSetting from "./ApproveTypeSetting";
import ApproveUserSetting from "./ApproveUserSetting";

export default {
  name: "ApproveManage",
  components: {
    ApproveTypeSetting,
    ApproveUserSetting,
  },
  data() {
    return {
      tab_index: 0,
    };
  },
  created() { },
  methods: {},
};
</script>
